export default "__VITE_ASSET__DbMTgGAd__"